// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/profile/v1/profile_api.proto (package gdx.gateway.web.profile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SearchCriteria, SearchProfile } from "./search_pb.js";
import { FullProfileInfo, ProfileFieldSettings, VerifiedBy } from "./profile_pb.js";

/**
 * @generated from message gdx.gateway.web.profile.v1.SearchRequest
 */
export class SearchRequest extends Message<SearchRequest> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.SearchCriteria criteria = 1;
   */
  criteria?: SearchCriteria;

  /**
   * @generated from field: string search_from = 2;
   */
  searchFrom = "";

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit = 0;

  constructor(data?: PartialMessage<SearchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "criteria", kind: "message", T: SearchCriteria },
    { no: 2, name: "search_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchRequest {
    return new SearchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchRequest {
    return new SearchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchRequest {
    return new SearchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchRequest | PlainMessage<SearchRequest> | undefined, b: SearchRequest | PlainMessage<SearchRequest> | undefined): boolean {
    return proto3.util.equals(SearchRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.profile.v1.SearchResponse
 */
export class SearchResponse extends Message<SearchResponse> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.SearchCriteria criteria = 1;
   */
  criteria?: SearchCriteria;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.SearchProfile profiles = 2;
   */
  profiles: SearchProfile[] = [];

  constructor(data?: PartialMessage<SearchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "criteria", kind: "message", T: SearchCriteria },
    { no: 2, name: "profiles", kind: "message", T: SearchProfile, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchResponse {
    return new SearchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchResponse {
    return new SearchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchResponse {
    return new SearchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchResponse | PlainMessage<SearchResponse> | undefined, b: SearchResponse | PlainMessage<SearchResponse> | undefined): boolean {
    return proto3.util.equals(SearchResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.profile.v1.GetProfileRequest
 */
export class GetProfileRequest extends Message<GetProfileRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.GetProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileRequest | PlainMessage<GetProfileRequest> | undefined, b: GetProfileRequest | PlainMessage<GetProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetProfileRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.profile.v1.GetProfileResponse
 */
export class GetProfileResponse extends Message<GetProfileResponse> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.FullProfileInfo profile = 1;
   */
  profile?: FullProfileInfo;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileFieldSettings field_settings = 2;
   */
  fieldSettings: ProfileFieldSettings[] = [];

  /**
   * For the first time it can be email verification flag.
   *
   * @generated from field: bool is_verified = 3;
   */
  isVerified = false;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  /**
   * @generated from field: bool is_blocked = 5;
   */
  isBlocked = false;

  /**
   * We have already liked this user.
   *
   * @generated from field: bool is_liked = 6;
   */
  isLiked = false;

  /**
   * Math means that we both liked each other.
   *
   * @generated from field: bool is_match = 7;
   */
  isMatch = false;

  /**
   * When user is deleted - property `profile` can be empty.
   *
   * @generated from field: bool is_deleted = 8;
   */
  isDeleted = false;

  /**
   * @generated from field: float distance = 9;
   */
  distance = 0;

  /**
   * @generated from field: string dialog_id = 10;
   */
  dialogId = "";

  /**
   * @generated from field: bool has_blocked_user = 11;
   */
  hasBlockedUser = false;

  /**
   * We have requested photo from this user.
   *
   * @generated from field: bool is_photo_requested = 12;
   */
  isPhotoRequested = false;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.VerifiedBy verified_by = 13;
   */
  verifiedBy: VerifiedBy[] = [];

  /**
   * indicates that user is shadow-banned
   *
   * @generated from field: bool is_special = 14;
   */
  isSpecial = false;

  /**
   * @generated from field: bool is_ai_generation_allowed = 15;
   */
  isAiGenerationAllowed = false;

  constructor(data?: PartialMessage<GetProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.GetProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: FullProfileInfo },
    { no: 2, name: "field_settings", kind: "message", T: ProfileFieldSettings, repeated: true },
    { no: 3, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_match", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "distance", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "has_blocked_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "is_photo_requested", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "verified_by", kind: "enum", T: proto3.getEnumType(VerifiedBy), repeated: true },
    { no: 14, name: "is_special", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "is_ai_generation_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileResponse | PlainMessage<GetProfileResponse> | undefined, b: GetProfileResponse | PlainMessage<GetProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetProfileResponse, a, b);
  }
}

